import React from 'react'
import { Flex, Separator, Button } from 'components/ds'
import style from '../index.module.css'

type FilterFooterProps = {
  onClearSelection: (e: React.MouseEvent<HTMLButtonElement>) => void
  onApplySelection: (e: React.MouseEvent<HTMLButtonElement>) => void
  isFilterUpdated: boolean
}

const FilterFooter = ({
  onClearSelection,
  onApplySelection,
  isFilterUpdated,
}: FilterFooterProps) => {
  return (
    <Flex
      position="sticky"
      bottom="0"
      gap="2"
      width="100%"
      direction="column"
      className={style.filterBadge_ClearSelectionContainer}
    >
      <Separator size="4" />
      <Flex direction="row" justify="between" align="center" pt="1">
        <Button
          variant="ghost"
          size="1"
          onClick={onClearSelection}
          className={style.filterBadge_ClearButton}
        >
          Clear
        </Button>
        <Button
          size="1"
          disabled={!isFilterUpdated}
          variant="solid"
          onClick={onApplySelection}
        >
          Apply
        </Button>
      </Flex>
    </Flex>
  )
}

export default FilterFooter
